export default "__VITE_ASSET__CEEjE9VM__"